import './components/styles/global.scss';
import './assets/styles/progallery-svg-font-icons.scss';
import './components/styles/gallery.scss';

import ProGallery from './components/gallery/proGallery';
import LoveButton from './components/item/loveButton/loveButton';
import GalleryItem from './components/item/galleryItem';
import {CommonItemContainer} from './components/item/commonItemContainer';

export {
    ProGallery,
    LoveButton,
    GalleryItem,
    CommonItemContainer
};



// WEBPACK FOOTER //
// ./index.js